export const RFP_STATUSES = {
  pendingAssignment: "Pending Assignment",
  underReview: "Under Review",
  outToMarket: "Out to Market",
  deliveredPartial: "Delivered Partial",
  deliveredFinal: "Delivered Final",
  complete: "Complete",
  direct: "Direct",
  withdrawn: "Withdrawn",
};
